import footer from "./en/footer_en.json";
import header from "./en/header_en.json";
import intro from "./en/intro_en.json";
import benefits from "./en/benefits_en.json";
import trial from "./en/trial_en.json";
import values from "./en/values_en.json";
import plans from "./en/plans_en.json";
import questions from "./en/questions_en.json";
import contact from "./en/contact_en.json";
import information from "./en/information_en.json";
import common from "./en/common_en.json";

export const en = {
  footer,
  header,
  intro,
  benefits,
  trial,
  values,
  plans,
  questions,
  contact,
  information,
  common,
};
